// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCPGvXSb9cJuYsFirIEmUZ-aT6gUMfcYzg",
  authDomain: "incubators-1f9cb.firebaseapp.com",
  projectId: "incubators-1f9cb",
  storageBucket: "incubators-1f9cb.appspot.com",
  messagingSenderId: "429681204765",
  appId: "1:429681204765:web:e6e0dbcd303efd1455b0f4",
  measurementId: "G-Y6YG5RPVB3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export { app, db, analytics };